module.exports = __WEBPACK_EXTERNAL_MODULE_redux__;